import React, { ChangeEvent } from "react";

type DateInputProps = {
  errorMessage?: string;
  extraClasses?: string;
  handleDateChange?: (value: string) => void;
  handleOnBlur?: () => void;
  hint?: string;
  label: string | JSX.Element;
  name: string;
  required?: boolean;
  value?: string;
};

export const DateInput: React.FC<DateInputProps> = ({
  errorMessage = "",
  extraClasses,
  handleDateChange,
  handleOnBlur,
  hint,
  label,
  name,
  required,
  value,
}) => {
  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    handleDateChange(event.target.value);
  };

  return (
    <div className="form_field">
      <div className={errorMessage && "form_field_error"}>
        <label className="heading_section" htmlFor={`${name}-date`}>
          {label}
        </label>
        <input
          className={`input_unlabeled ${extraClasses ? `${extraClasses}` : ""}`}
          id={`${name}-date`}
          name={name}
          onBlur={handleOnBlur}
          onChange={handleInputChange}
          required={required}
          type="date"
          value={value}
        />
      </div>
      {errorMessage && (
        <span className="form_field_helper form_field_helper_error">
          {errorMessage}
        </span>
      )}
      {hint && <span className="form_field_helper">{hint}</span>}
    </div>
  );
};
